<template>
  <div :id="backgroundImageId()" class="login_container" :style="{ 'background-image': backgroundImage() }">
    <SignUp v-if="showSignUp" :context="'clientarea'" @usersigned="UserSignedInOrSignedUp" @showLoginClicked="showLoginClicked" />
    <SignIn v-else :context="'clientarea'" @usersigned="UserSignedInOrSignedUp" @showSignUpClicked="showSignUpClicked" />
  </div>
</template>

<script>

import SignIn from '../../../components/auth/SignIn';
import SignUp from '../../../components/auth/SignUp';
import SocialLogins from '../../../mixins/socialLogins';
import logr from '../../../mixins/LogRocket';

export default {
  components: {
    SignIn, SignUp,
  },

  mixins: [SocialLogins, logr],

  data() {
    return {
      showSignUp: false,
      images: [
        { url: require('../../../assets/img/src/clientArea/Margarita.png'), id: '1' },
        { url: require('../../../assets/img/src/clientArea/crossing-the-rock.png'), id: '2' },
        { url: require('../../../assets/img/src/clientArea/Il-Tabacchificio.png'), id: '3' },
        { url: require('../../../assets/img/src/clientArea/Iola.png'), id: '4' },
        { url: require('../../../assets/img/src/clientArea/Lithia.png'), id: '5' },
      ],
      randomImageIndex: -1,
    };
  },

  mounted() {
    // initialise FB and google SDK to prevent issues on mobile 1st time load (SocialLogins mixin)
    this.initFacebook();
    this.initGoogle();

    // NEW GA - push Custom GTM pageView event (on each page template)
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'Pageview', id_villa: undefined, page_type: 'SCA' });
  },

  created() {
    // only initialise logrocket for production(live) when client is checking out
    if (process.env.NODE_ENV === 'production') {
      this.initLogRocket();
    }
  },

  methods: {

    UserSignedInOrSignedUp() {
      console.log('not implemented');
    },

    showSignUpClicked() {
      this.showSignUp = true;
    },

    showLoginClicked() {
      this.showSignUp = false;
    },

    backgroundImage() {
      return `url("${this.images[this.randomNumber()].url
      }")`;
    },

    randomNumber() {
      if (this.randomImageIndex === -1) {
        this.randomImageIndex = Math.floor(Math.random() * this.images.length);
      }
      return this.randomImageIndex;
    },

    backgroundImageId() {
      return this.images[this.randomNumber()].id;
    },

  },
  metaInfo() {
    return {
      meta: [
        {
          property: 'og:image',
          content: 'https://www.thethinkingtraveller.com/media/Web/ttt-preview-logo-new.png',
        },
        {
          property: 'og:title',
          content: 'My Account - Login',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/settings/config.scss";
  .login_container {
    background-size: cover;
    background-color: $cornflower;
    background-position: 13% 50%;
    background-repeat: no-repeat;
    height: 785px;
    display: flex;
    align-items: center;
    justify-content: center;

    @include mobile{
      align-items: flex-start;
      justify-content: center;
    }

  }

</style>
